import {Component, Inject, inject, Input, OnInit} from '@angular/core';
import {FormBuilder, FormControl, FormGroup, Validators} from "@angular/forms";
import {WorkflowhttpService} from "@app/workflow-common/services/workflowhttp.service";
import {WorkflowObservableService} from "@app/workflow-common/services/workflow-observable.service";
import {SidebarNavService} from "@app/shared/cs-components/sidebar-nav/services/sidebar-nav.service";
import {CsToastBoxService} from "@app/services";

@Component({
  selector: 'app-basic-details-step',
  templateUrl: './basic-details-step.component.html',
  styles: []
})
export class BasicDetailsStepComponent implements OnInit {

    @Input() workflowData = undefined;
    @Input() objectName: string;
    @Input() settingsTypeId: number;
    @Input() screenName: string;
    @Input() closeFullScreenModal: Function = undefined;
    @Input() sidebarNavService: SidebarNavService;
    @Input() isDraftMode: boolean = true;

    name: string = '';
    description: string = '';
    workflowId: number = 0;

    form: FormGroup;
    isSaving: boolean = false;
    currentStep: string = 'basic_details'

    constructor(
        private _formBuilder: FormBuilder,
        private _workflowHttp: WorkflowhttpService,
        public workflowObservableService$: WorkflowObservableService,
        private toastBox: CsToastBoxService
    ) { }

    ngOnInit() {

        if(this.workflowData) {
            this.name = this.workflowData['name'];
            this.description = this.workflowData['description'];
            this.workflowId = this.workflowData['id'];
        }

        this.form = this._formBuilder.group({
            id: new FormControl(this.workflowId),
            name: new FormControl(this.name, [Validators.required]),
            description: new FormControl(this.description)
        });
    }

    save() {
        this.isSaving = true;
        this._workflowHttp.saveCustomAutomation(
            this.screenName,
            this.settingsTypeId,
            this.objectName,
            {customAutomationSave: this.form.value}
        ).subscribe({
            next: (resp) => {
                if(resp.hasOwnProperty('customAutomationSave')) {
                    const data = resp['customAutomationSave'];

                    this.workflowObservableService$.setWorkflowData(data);
                    this.workflowData=data;
                    this.sidebarNavService.goToNext(this.currentStep);
                }
                else {
                    this.toastBox.show(resp['message']);
                    console.error(resp);
                }
            },
            error: err => console.error(err)
        });
    }

}
